module.exports = __webpack_public_path__ + "img/star.eccb345d.svg";